
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class QualityInspectionValuesGrid extends Serenity.EntityGrid<QualityInspectionValuesRow, any> {
        protected getColumnsKey() { return 'Production.QualityInspectionValues'; }
        protected getDialogType() { return QualityInspectionValuesDialog; }
        protected getIdProperty() { return QualityInspectionValuesRow.idProperty; }
        protected getInsertPermission() { return QualityInspectionValuesRow.insertPermission; }
        protected getLocalTextPrefix() { return QualityInspectionValuesRow.localTextPrefix; }
        protected getService() { return QualityInspectionValuesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}